import React, { useState } from "react";
import { Lock } from "lucide-react";
import { useAuth } from "./AuthProvider.jsx";

/**
 * Replaces the v10 LoginGate. Same look; the password check now happens in
 * Supabase Auth against a hash instead of against a plaintext string held in
 * the browser.
 *
 * Deliberately gone from the old version: self-signup, the recovery-phrase
 * reset, and the admin panel that displayed passwords. Accounts are created in
 * the Supabase dashboard and granted a role with `npm run grant`.
 */
export default function LoginGate() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    setErr("");

    if (!email.trim() || !password) {
      setErr("Enter your email and password.");
      return;
    }

    setBusy(true);
    const { error } = await signIn(email.trim(), password);
    setBusy(false);

    if (!error) return; // AuthProvider picks up the session

    // Supabase returns "Invalid login credentials" for both a wrong password
    // and an unknown address, which is correct — distinguishing them would let
    // anyone test which addresses have accounts.
    setErr(
      /email not confirmed/i.test(error.message)
        ? "That account has not been confirmed yet. An admin can confirm it in Supabase."
        : /invalid login/i.test(error.message)
          ? "Wrong email or password."
          : error.message
    );
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-top">
          <div className="wordmark">
            HAL<span>CO</span> OPS
          </div>
          <div className="sub">Equipment Rentals · North TX</div>
        </div>
        <div className="login-body">
          <div className="fld">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoComplete="username"
              autoFocus
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="fld">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {err && (
            <div className="notice red" style={{ margin: 0 }}>
              {err}
            </div>
          )}

          <button
            className="btn primary"
            type="submit"
            disabled={busy}
            style={{ justifyContent: "center", padding: 11 }}
          >
            <Lock size={15} /> {busy ? "Signing in…" : "Sign in"}
          </button>

          <div style={{ fontSize: 12, color: "var(--muted)", textAlign: "center" }}>
            Forgot your password? An admin can reset it in Supabase.
          </div>
        </div>
      </form>
    </div>
  );
}
